import { getCDN, getCroppedUrl } from '../utility';

const MOBILE_LOGO_HEIGHT = 28;
const MOBILE_LOGO_WIDTH = 132;
const MOBILE_LOGO_RESOLUTION = 1.5;

export const Z_LOGO_BLACK = getCDN(
  '/web_assets/b40b97e677bc7b2ca77c58c61db266fe1603954218.png',
);
export const Z_LOGO_WHITE = getCDN(
  '/web_assets/ee34583804919f1d9d5a45a32db80a891604300478.png',
);
export const Z_LOGO_WHITE_BIG = getCDN(
  '/web_assets/1587250f42958c80332fc592559f05661603954264.png',
);
export const FOOD_AT_WORK_LOGO_IMG = getCDN(
  '/data/o2_assets/d385bc2999c27b8571b84df4921b34d81691414310.png',
);
export const FOOD_AT_WORK_IMG = getCDN(
  '/data/o2_assets/ff567704bbe8546c85f4671d708c4ca41613492028.png',
);
export const DEFAULT_COMPANY_LOGO = getCDN(
  '/data/o2_assets/e9c2e9ebd9e316253a1863f70fdbe0e61692186415.png',
);
export const CROPPED_Z_LOGO_BLK = getCroppedUrl(
  Z_LOGO_BLACK,
  MOBILE_LOGO_WIDTH,
  MOBILE_LOGO_HEIGHT,
  MOBILE_LOGO_RESOLUTION,
);

export const Z_LOGO_IMG = getCDN(
  '/web/assets/7c86b742bd6ea6a45d5753abaab025201608640583.png',
);

export const EMPTY_STATE_IMG = getCDN(
  '/data/o2_assets/9eb246f828f8d75c00fd904b6df498511612355731.png',
);

export const AWW_SNAP_IMG = getCDN(
  '/web/crystal/snapaec5323792a0f1a1492529bc21364dfa1577955444.png',
);

export const DASHBOARD_EMPTY_IMG = getCDN(
  '/data/o2_assets/196694e4ba2384936dcc8bf8f16022471696586298.png',
);

export const EMPLOYEES_EMPTY_IMG = getCDN(
  '/data/o2_assets/b2cc51352b9483c4015bb4d342375a051696945372.png',
);

export const PROGRAMS_EMPTY_IMG = getCDN(
  '/data/o2_assets/dd6267b84b50fff12e4b1bd93ed1bf6d1696586327.png',
);

export const PAYMENTS_EMPTY_IMG = getCDN(
  '/data/o2_assets/a75aa4fedbac98e3a7d7687eb3821c781696945359.png',
);
